import { render, staticRenderFns } from "./headerCom.vue?vue&type=template&id=c1e5ed60&scoped=true&"
import script from "./headerCom.vue?vue&type=script&lang=js&"
export * from "./headerCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e5ed60",
  null
  
)

export default component.exports